import { Route } from 'react-router-dom';
import SkeletonPage from '../modules/skeleton/SkeletonPage';
import { Suspense, lazy } from 'react';

const Logistics = lazy(() => import('../modules/logistics'));
const LogisticsSection = lazy(() => import('../modules/logistics/pages/LogisticsSection'));
const NewLogisticsSection = lazy(() => import('../modules/logistics/pages/NewLogistics'));
const LogisticsDetails = lazy(() => import('../modules/logistics/pages/LogisticsDetails'));
const EditLogistics = lazy(() => import('../modules/logistics/pages/EditLogistics'));

const LogisticsRoutes = (
  <>
    <Route
      path="logistics"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <Logistics />
        </Suspense>
      }
    >
      <Route
        path=""
        element={
          <Suspense fallback={<SkeletonPage />}>
            <LogisticsSection />
          </Suspense>
        }
      />
      <Route
        path="new"
        element={
          <Suspense fallback={<SkeletonPage />}>
            <NewLogisticsSection />
          </Suspense>
        }
      />
      <Route
        path="edit/:id"
        element={
          <Suspense fallback={<SkeletonPage />}>
            <EditLogistics />
          </Suspense>
        }
      />
      <Route
        path="details/:id"
        element={
          <Suspense fallback={<SkeletonPage />}>
            <LogisticsDetails />
          </Suspense>
        }
      />
    </Route>
  </>
);

export default LogisticsRoutes; 